export default "__VITE_ASSET__ce695c09__"